import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, map } from 'rxjs';
import { WorkspaceIdRequest } from '../../../../../backend/src/core/request-response';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import {
  UnipileGate,
  UnipileSendInvitationRequest,
  UnipileSendMessageRequest,
} from '../../../../../backend/src/core/unipile/unipile.gate';
import { LambdaService } from '../../shared/core/lambda.service';
import { CoreItemService } from '../core-item/core-item.service';
import { LeadsService } from '../leads/leads.service';
import { WorkspaceHolderService } from '../workspace/workspace.holder.service';

@Injectable({
  providedIn: 'root',
})
export class UnipileService {
  constructor(
    private workspaceHolderService: WorkspaceHolderService,
    private lambdaService: LambdaService,
    private coreItemService: CoreItemService,
    private messageService: NzMessageService,
    private leadsService: LeadsService
  ) {}

  isConnected$(): Observable<boolean> {
    const request: WorkspaceIdRequest = {
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
    };

    return this.lambdaService
      .run$(ResourceName.unipile, UnipileGate.actions.isConnected, request)
      .pipe(map((response) => response.isConnected));
  }

  getMessageList$(chatId: string) {
    return this.lambdaService.run$(ResourceName.unipile, UnipileGate.actions.getMessageListByChatId, { chatId }).pipe(
      map((response) => {
        return response.data;
      })
    );
  }

  sendInvitation$(leadsId: string) {
    const request: UnipileSendInvitationRequest = {
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
      leadsId,
    };

    return this.lambdaService.run$(ResourceName.unipile, UnipileGate.actions.sendInvitation, request).pipe(
      map((response) => {
        if (response.isSuccess === false) {
          this.messageService.error(`Invite failed: ${response.errMessage}`);
        } else {
          this.coreItemService.updateCoreItemInCache(response);
          this.leadsService.change();
        }
      })
    );
  }

  sendMessage$(leadsId: string) {
    const request: UnipileSendMessageRequest = {
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
      leadsId,
    };

    return this.lambdaService.run$(ResourceName.unipile, UnipileGate.actions.sendSecondMessage, request).pipe(
      map((response) => {
        if (response.isSuccess === false) {
          this.messageService.error(`Send message failed: ${response.errMessage}`);
        } else {
          this.coreItemService.updateCoreItemInCache(response);
          this.leadsService.change();
        }
      })
    );
  }
}
